import { MotifAvatar } from '@ey-xd/motif-wc-react';
import { useHeaderStore } from '@/header/header-store';
import { getTracker } from '@/telemetry/tracker';
import { useUserAvatar } from '@/header/user-avatar';
import { useUserDisplay } from '@/header/use-user-display';

/**
 * Header avatar. Opens the right-side "My Account" slide-in panel — matching
 * the legacy `ey-global-header` `(avatarClicked)` → `app-ey-header-user`
 * flyout (name / email / log out / notification preferences), instead of a
 * small inline dropdown.
 */
export function UserMenu() {
  const togglePanel = useHeaderStore((s) => s.togglePanel);
  const { name, email, avatarSeed } = useUserDisplay();
  const { data: avatarSrc = '' } = useUserAvatar(email);

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        getTracker().event('Header-user');
        // Legacy `avatarClicked` only toggles the user flyout via `showMenu`; it
        // never touches the popup outlet, so the orchestrator/chatbot MFE stays open.
        togglePanel('user');
      }}
      onMouseDown={(e) => e.stopPropagation()}
      style={{
        background: 'transparent',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        display: 'inline-flex',
      }}
      aria-label="My Account"
      title={name || 'My Account'}
    >
      <MotifAvatar
        size="xs"
        variant={avatarSrc ? 'image' : 'initials'}
        src={avatarSrc || undefined}
        userName={name}
        initialsTextOverride={avatarSrc ? undefined : avatarSeed || undefined}
        showDefaultTooltip={false}
      />
    </button>
  );
}
